export enum Tenancy {
  DEV = "dev",
  LIVE = "live",
  LIVE_SANDBOX = "live/sandbox",
}

export const LIVE_AND_SANDBOX_TENANCIES = [Tenancy.LIVE, Tenancy.LIVE_SANDBOX] as const;
